import { Lootbox, LootboxStage } from '@/api/common';
import { RecentGame } from '@/api/games';

export const findActiveLootboxId = (
  lootboxes: Lootbox[]
): number | undefined => {
  return lootboxes.find((lootbox) => lootbox.stage === LootboxStage.Issued)?.id;
};

export const checkIfLootboxActiveById = (
  lootboxes: Lootbox[],
  lootboxId: number
) => {
  return lootboxes.some(
    (lootbox) =>
      lootbox.id === lootboxId && lootbox.stage === LootboxStage.Issued
  );
};

export function updateRecentsWithNewGame(
  array: string[],
  newItem: RecentGame
): string[] {
  const index = array.findIndex(
    (identifier) => identifier === newItem.identifier
  );

  if (index > -1) {
    return [array[index], ...array.filter((_, i) => i !== index)];
  } else {
    return [newItem.identifier, ...array];
  }
}

export const LOOTBOX_WHEEL_TITLES = ['(wheel_', 'Wheel', 'wheel'];

export const isWheelLootbox = (lootbox: Lootbox) =>
  LOOTBOX_WHEEL_TITLES.some((LOOTBOX_WHEEL_TITLES) =>
    lootbox.title.includes(LOOTBOX_WHEEL_TITLES)
  );

export const updateBonuses = <T extends { id: number }>(
  bonuses: T[],
  incomingBonus: T
) => {
  const isIncomingBonusOld = bonuses.some(({ id }) => incomingBonus.id === id);

  return isIncomingBonusOld
    ? bonuses.map((bonus) =>
        bonus.id === incomingBonus.id ? incomingBonus : bonus
      )
    : [...bonuses, incomingBonus];
};
